import RequireAuth from '../Components/RequireAuth';
import { Routes, Route } from 'react-router-dom';
import AddStory from './News/AddStory';
import Stories from './News/Stories';
import Story from './News/Story';

function News({img, cat}) {
  return (
    <Routes>
      <Route exact path='/' element={<Stories img={img} cat={cat}/>} />
      <Route exact path='/view/:id' element={<Story img={img} cat={cat}/>} />
      <Route element={<RequireAuth allowedRoles={[3, 4, 5]} />}>
        <Route exact path='/add' element={<AddStory img={img} cat={cat}/>} />
      </Route>
    </Routes>
  )
}

export default News